import { render, staticRenderFns } from "./subMyPage.vue?vue&type=template&id=6f9ccf12&scoped=true&"
import script from "./subMyPage.vue?vue&type=script&lang=js&"
export * from "./subMyPage.vue?vue&type=script&lang=js&"
import style0 from "./subMyPage.vue?vue&type=style&index=0&id=6f9ccf12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9ccf12",
  null
  
)

export default component.exports